/**
 * @name Topbar
 * @description Componente topbar de Talentry
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Lines } from '@components';
import { Icons, MUI, Typography } from '@styles';

import MenuAdmin from './components/menu-admin';
import MenuApps from './components/menu-apps';
import MenuNotifications from './components/menu-notifications';
import MenuUser from './components/menu-user';
import Sidebar from './components/sidebar';

// Material-UI
import MuiAppBar from '@material-ui/core/AppBar';
import MuiToolbar from '@material-ui/core/Toolbar';

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSidebar: false,
      isExternal: Boolean(JSON.parse(localStorage.getItem('ls.infoUsuario')).EsExterno)
    };
  }

  componentDidMount() { }

  goBack = (history) => {
    history.goBack();
  }

  sidebarToggleHandler = () => {
    const { openSidebar } = this.state;
    this.setState({ openSidebar: !openSidebar });
  }

  render() {
    const {
      openSidebar,
      isExternal
    } = this.state;

    return (
      <>
        {/* Topbar */}
        <Styled.AppBar>
          <Styled.Toolbar>
            {!isExternal && (
              <>
                {/* Sidebar (Menú Lateral) */}
                {(!this.props.showBackButton && this.props.showSidebar) && (
                  <Styled.BoxTopbarIcon onClick={() => this.sidebarToggleHandler()}>
                    <MUI.Tooltip title={i18n.t('GenericMessages.sidebar')}>
                      {!openSidebar ? <Icons.Menu /> : <Icons.Close />}
                    </MUI.Tooltip>
                  </Styled.BoxTopbarIcon>
                )}

                <Sidebar
                  open={openSidebar}
                  appName={this.props.appName}
                  history={this.props.history}
                  sidebarActions={this.props.sidebarActions}
                  sidebarChildren={this.props.sidebarChildren}
                  onSidebarToggle={this.sidebarToggleHandler}
                />

                {/* GoBack Button */}
                {this.props.showBackButton && (
                  <Styled.BoxTopbarIcon onClick={() => this.goBack(this.props.history)}>
                    <Icons.ArrowBack />
                    <MUI.Box padding="8px">
                      <Typography.Text>{i18n.t('Topbar.goBack')}</Typography.Text>
                    </MUI.Box>
                  </Styled.BoxTopbarIcon>
                )}
              </>
            )}

            <Styled.TalentryLogo
              src="https://assets.talentry.io/logo/TAL_logo.svg"
              alt="Talentry"
            />

            {this.props.appIcon && (
              <>
                <Styled.Divider orientation="vertical" />
                <Styled.AppIcon
                  src={this.props.appIcon}
                  alt={this.props.appName}
                />
                {/* <Styled.AppName>
                  {this.props.appName}
                </Styled.AppName> */}
              </>
            )}

            <Styled.Span />

            {!isExternal && (
              <>
                {/* Menú Notificaciones */}
                <MenuNotifications />

                {/* Menú Apps */}
                <MenuApps
                  history={this.props.history}
                />

                {/* Menú Administrador */}
                <MenuAdmin
                  history={this.props.history}
                  appName={this.props.appName}
                  adminActions={this.props.adminActions}
                />
              </>
            )}

            {/* Menú Usuario */}
            <MenuUser
              history={this.props.history}
              isExternal={isExternal}
            />
          </Styled.Toolbar>

          <Lines
            direction="horizontal"
            firstLine={{ size: 75, color: 'blueMedium' }}
            secondLine={{ size: 25, color: 'red' }}
          />
        </Styled.AppBar>
      </>
    );
  }
}

Topbar.propTypes = {
  // History router.
  history: PropTypes.object,
  // Nombre de la aplicación de Talentry.
  appName: PropTypes.string,
  // URL del icono de la aplicación de Talentry.
  appIcon: PropTypes.string,
  // Array de acciones de administrador
  adminActions: PropTypes.array,
  // Array de acciones de sidebar.
  sidebarActions: PropTypes.array,
  // Componente de React dentro del Drawer.
  sidebarChildren: PropTypes.node,
  // Boolean que indica si se muestra el botón de 'Regresar'.
  showBackButton: PropTypes.bool,
  // Boolean que indica si se muestra el menú lateral.
  showSidebar: PropTypes.bool,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.AppBar = styled(MuiAppBar)`
   && {
     padding-right: 0px !important;
     box-shadow: none;
   }  
 `;

Styled.Toolbar = styled(MuiToolbar)`
   && {
     padding-right: 0px;
     padding-left: 0px;
     min-height: 60px;
     max-height: 60px;
     color: ${(props) => props.theme.colors.greyDark};
     background: ${(props) => props.theme.colors.white};
   }
 `;

Styled.TalentryLogo = styled.img`
   height: 60px;
   margin: 5px 0 0 0;
 `;

Styled.Span = styled.span`
   flex: 1;
   box-sizing: border-box;
 `;

Styled.BoxTopbarIcon = styled(MUI.ButtonText)`
   &.MuiButton-root{
     display: flex;
     min-width: 60px;
     width: auto;
     height: 60px;
     padding: 12px;
     margin: 0;
 
     &:hover {
       text-decoration: none;
       background-color: ${(props) => props.theme.colors.greyHover};
       border-radius: 0%;
     }
   }
 `;

Styled.Divider = styled(MUI.Divider)`
   height: 30px;
 `;

Styled.AppName = styled.div`
   display: flex;
   align-items: center;
   height: 60px;
   padding: 12px;
   font-family: 'Bryant Pro Medium';
   font-size: ${(props) => props.theme.typography.bodyText};
 `;

Styled.AppIcon = styled.img`
   height: 30px;
   margin: 0px 0px 0px 16px;
 `;

export default Topbar;
